import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './lib/auth'
import { AuthGuard } from './components/common/AuthGuard'
import { AppLayout } from './components/layout/AppLayout'
import { LoginPage } from './components/common/LoginPage'
import { Toaster } from '@/components/ui/toaster'
import { TooltipProvider } from './components/ui/tooltip'
import { ThemeProvider } from './lib/theme'

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="memora-ui-theme">
      <TooltipProvider>
        <AuthProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <div className="h-screen bg-background text-foreground">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route
                  path="/*"
                  element={
                    <AuthGuard>
                      <AppLayout />
                    </AuthGuard>
                  }
                />
              </Routes>
              <Toaster />
            </div>
          </Router>
        </AuthProvider>
      </TooltipProvider>
    </ThemeProvider>
  )
}

// Simple auth callback component for email confirmations
function AuthCallback() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h2 className="text-lg font-semibold">Confirming your account...</h2>
        <p className="text-muted-foreground">Please wait while we confirm your email.</p>
      </div>
    </div>
  )
}

export default App
